import { Button } from "@chakra-ui/button";
import { Box } from "@chakra-ui/layout";
import { Col, Modal, Row, SelectProps } from "antd";
import useGetIndexadores from "core/features/indexador/hooks/useGetIndexadores";
import colors from "core/resources/theme/colors";
import { useEffect, useState } from "react";
import { BiEdit } from "react-icons/bi";
import SelectBaseAntd from "ui/components/Input/SelectBaseAntd";
import FormIndexador from "./FormIndexador";

export interface SelectIndexadorProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
  isInvalid?: boolean;
  errorMessage?: string;
  valorUnitario?: number;
}

function SelectIndexador({
  value,
  onChange,
  isInvalid,
  errorMessage,
  valorUnitario = 0,
  ...rest
}: SelectIndexadorProps) {
  const { isLoading, isFetching, data, refetch } = useGetIndexadores();
  const [indexadorEditId, setIndexadorEditId] = useState<string | undefined>(
    undefined
  );
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [search, setSearch] = useState<string>();

  useEffect(() => {
    if (!isOpenModal) {
      setSearch("");
      setIndexadorEditId(undefined);
    }
  }, [isOpenModal]);

  useEffect(() => {
    if (indexadorEditId) {
      setIsOpenModal(true);
    }
  }, [indexadorEditId]);

  return (
    <>
      <Modal
        centered
        visible={isOpenModal}
        footer={null}
        destroyOnClose
        onCancel={() => setIsOpenModal(false)}
        closable={false}
        width={"max(900px, 80vw)"}
        bodyStyle={{
          height: "max(95vh, 450px)",
          overflow: "auto",
          paddingBottom: 16,
        }}
      >
        <FormIndexador
          valorUnitario={valorUnitario}
          indexadorEditId={indexadorEditId}
          visible={isOpenModal}
          onClose={() => setIsOpenModal(false)}
          onSuccess={async (id) => {
            onChange(id);

            await refetch();

            setIsOpenModal(false);
          }}
        />
      </Modal>

      <Box as={Row} gutter={24} alignItems="center">
        <Col sm={19}>
          <SelectBaseAntd
            isInvalid={isInvalid}
            loading={isLoading || isFetching}
            size="large"
            placeholder="Selecione o peso"
            style={{ width: "100%", flexGrow: 1, flex: 1 }}
            value={value || undefined}
            onChange={onChange}
            {...rest}
            showSearch
            allowClear={false}
            searchValue={search}
            onSearch={(v) => {
              if (!isOpenModal) {
                setSearch(v);
              }
            }}
            optionFilterProp="label"
            options={data?.map((item) => ({
              value: item.id,
              label: item.nome,
            }))}
            notFoundContent={
              <Box>
                Nenhum peso encontrado{" "}
                <Button
                  leftIcon={<i className="mdi mdi-plus" />}
                  size="xs"
                  colorScheme="orange"
                  onClick={() => setIsOpenModal(true)}
                >
                  cadastrar novo
                </Button>
              </Box>
            }
          />
        </Col>

        <Box as={Col} sm={5}>
          {!!value ? (
            <BiEdit
              color={colors.primary}
              size={24}
              onClick={() => setIndexadorEditId(value)}
              cursor="pointer"
              aria-label="Editar peso"
              aria-roledescription="Botão de editar peso"
              style={{ marginTop: "auto", marginBottom: "auto" }}
            />
          ) : null}
        </Box>
      </Box>
    </>
  );
}

export default SelectIndexador;
